import { useState, useEffect } from 'react';
import styled from 'styled-components';

import AdminNavbar from '../../../components/Admin/AdminNavbar';
import PrivateLayout from '../../../layout/PrivateLayout';
// import Loader from '../../../components/Admin/Loader';
import { Container } from './../../../styles/Common';
import Card from './Card';
import { toast } from 'react-toastify';
import { getAllQuoteCountApi } from './../../../apis/index';
import Loader from '../../../components/Admin/Loader';

const DashboardPage = () => {
  const [isAllQuoteCounting, setIsAllQuoteCounting] = useState<boolean>(false);

  const [quoteCount, setQuoteCount] = useState<any>({});

  const handleAllQuoteCount = async () => {
    try {
      setIsAllQuoteCounting(true);
      const { data } = await getAllQuoteCountApi();
      setQuoteCount(data?.data);
      setIsAllQuoteCounting(false);
    } catch (error: any) {
      setIsAllQuoteCounting(false);
      toast.error(error.response.data.message || 'Something went wrong.');
    }
  };

  useEffect(() => {
    handleAllQuoteCount();
  }, []);

  return (
    <>
      <PrivateLayout>
        <title>Dashboard | Ripify</title>
        <AdminNavbar />
        <Container>
          <CardsWrapper>
            <Card
              toPath="/admin/dashboard/quotes/all/page/1"
              title="Total Quotes"
              number={quoteCount?.all || 0}
            />
            <Card
              toPath="/admin/dashboard/quotes/marked-as-read/page/1"
              title="Marked As Read"
              number={quoteCount?.markAsRead || 0}
            />
            <Card
              toPath="/admin/dashboard/quotes/marked-as-unread/page/1"
              title="Marked As Unread"
              number={quoteCount?.markAsUnread || 0}
            />
          </CardsWrapper>
          {/* <Loader /> */}
        </Container>
      </PrivateLayout>
      <>{isAllQuoteCounting && <Loader />}</>
    </>
  );
};

export default DashboardPage;

const CardsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
`;
